import { render } from "./FinancialActivitiesBalance.vue?vue&type=template&id=afe9b214&scoped=true"
import script from "./FinancialActivitiesBalance.vue?vue&type=script&lang=js"
export * from "./FinancialActivitiesBalance.vue?vue&type=script&lang=js"

import "./FinancialActivitiesBalance.vue?vue&type=style&index=0&id=afe9b214&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe9b214"]])

export default __exports__